import ReactGA from 'react-ga4';

const GA_ID = 'G-FYXTQXKX7G';
const isProduction = window.location.hostname !== 'localhost';

export const initAnalytics = () => {
    if (!isProduction) return;
    ReactGA.initialize(GA_ID, { gaOptions: { send_page_view: false } });
};

export const trackPageView = (path, title) => {
    if (!isProduction) return;
    ReactGA.send({ hitType: 'pageview', page: path, title });
};

export const setAnalyticsUser = (userId) => {
    if (!isProduction) return;
    ReactGA.gtag('set', { user_id: userId });
    ReactGA.gtag('set', 'user_properties', { user_type: 'registered' });
};

export const clearAnalyticsUser = () => {
    if (!isProduction) return;
    ReactGA.gtag('set', { user_id: null });
    ReactGA.gtag('set', 'user_properties', { user_type: 'guest' });
};

// Auth
export const trackLogin = (method = 'email') => {
    if (!isProduction) return;
    ReactGA.event('login', { method });
};

export const trackSignUp = (method = 'email') => {
    if (!isProduction) return;
    ReactGA.event('sign_up', { method });
};

// Search
export const trackSearch = (term) => {
    if (!isProduction) return;
    ReactGA.event('search', { search_term: term });
};

// Posts
export const trackPostView = (postId, category) => {
    if (!isProduction) return;
    ReactGA.event('post_view', { post_id: postId, category });
};

export const trackPostCreate = (category) => {
    if (!isProduction) return;
    ReactGA.event('post_create', { category });
};

export const trackPostRate = (postId, ratingType) => {
    if (!isProduction) return;
    ReactGA.event('post_rate', { post_id: postId, rating_type: ratingType });
};

// Comments
export const trackCommentCreate = (postId) => {
    if (!isProduction) return;
    ReactGA.event('comment_create', { post_id: postId });
};

export const trackCommentRate = (ratingType) => {
    if (!isProduction) return;
    ReactGA.event('comment_rate', { rating_type: ratingType });
};

// Bookmarks
export const trackBookmarkAdd = (postId) => {
    if (!isProduction) return;
    ReactGA.event('bookmark_add', { post_id: postId });
};

export const trackBookmarkRemove = (postId) => {
    if (!isProduction) return;
    ReactGA.event('bookmark_remove', { post_id: postId });
};

// Subscriptions
export const trackSubscribeUser = () => {
    if (!isProduction) return;
    ReactGA.event('subscribe_user');
};

export const trackUnsubscribeUser = () => {
    if (!isProduction) return;
    ReactGA.event('unsubscribe_user');
};
